export async function sendFeedbackForm(data) {
  try {
    console.log("Sending feedback data to API:", data);
    console.log(
      "API URL:",
      `${process.env.REACT_APP_API_URL}/sendFeedbackForm`
    );

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/sendFeedbackForm`,
      {
        method: "POST",
        headers: {
          accept: "application/json",
          "content-type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );

    const result = await response.json();
    console.log("API response:", result);

    // Handle validation error format (array) or success format (object)
    if (Array.isArray(result)) {
      // Backend returned validation errors as array (likely Zod validation errors)
      console.log(
        "Backend validation errors:",
        JSON.stringify(result, null, 2)
      );
      const firstError = result[0];
      let errorMessage = "Validation error";

      // Try to extract error message from various possible formats
      if (firstError?.errors?.issues?.[0]?.message) {
        errorMessage = firstError.errors.issues[0].message;
      } else if (firstError?.message) {
        errorMessage = firstError.message;
      } else if (firstError?.path) {
        // Format: "Field name: error message"
        const fieldName = Array.isArray(firstError.path)
          ? firstError.path.join(".")
          : firstError.path;
        errorMessage = `${fieldName}: ${firstError.message || "Invalid value"}`;
      }

      // Log the full error structure for debugging
      console.error("Extracted error message:", errorMessage);
      console.error("Full error object:", firstError);

      return {
        success: false,
        message: errorMessage,
        errors: result,
      };
    }

    // Check if response indicates success
    if (!response.ok) {
      return {
        success: false,
        message: result.message || `Server error: ${response.status}`,
        errors: result,
      };
    }

    // Return result (should have success property)
    return result;
  } catch (error) {
    console.error("Error sending feedback:", error);
    throw error;
  }
}
